import { graphql, useStaticQuery } from 'gatsby';

import { useMemo } from 'react';

export const useAllProductReviews = (): Queries.allProductReviewsNodeFragmentFragment[] => {
    const queryResult = useStaticQuery(graphql`
        query allProductReviews {
            allProductReviews: allProductReviewsJson {
                nodes {
                    ...allProductReviewsNodeFragment
                }
            }
        }
    `);

    return useMemo(() => {
        const { allProductReviews } = queryResult;
        return allProductReviews.nodes;
    }, [queryResult]);
};
